import { Suspense } from "react";
import PageLoader from "../layouts/PageLoader";

export default ( Component ) => ( props ) => (
    <Suspense fallback={<PageLoader />}>
        <Component { ...props } />
    </Suspense>
) 